var TreeComponent = (function () {
    function TreeComponent() {
        this.controllerAs = 'vm';
        this.templateUrl = 'tree.html';
        this.controller = TreeController;
        this.bindings = treeBind;
    }
    return TreeComponent;
}());

//# sourceMappingURL=treeComponent.js.map
